module.exports = __webpack_public_path__ + "img/jibie_top1.79cc727b.png";